import React, { FC } from 'react';
import { VeksthusPanel } from './DefaultPanel';
import { BlinkPanel } from './BlinkPanel';
import type { BlinkTraffic } from 'effect-apis-client';

export type DeviceType = 'mobile' | 'tablet' | 'desktop';

export type AppProps = {
    blinkTraffic?: BlinkTraffic;
    defaultRender: boolean;
    deviceType: DeviceType;
};

export const App: FC<AppProps> = ({ defaultRender, deviceType, blinkTraffic }) => {
    if (defaultRender) return <VeksthusPanel deviceType={deviceType} />;

    return <BlinkPanel deviceType={deviceType} blinkTraffic={blinkTraffic} />;
};
